var map = {
	"./cs.json": [
		68593,
		68593
	],
	"./de.json": [
		32340,
		32340
	],
	"./en.json": [
		52048,
		52048
	],
	"./es.json": [
		82407,
		82407
	],
	"./fr.json": [
		2707,
		2707
	],
	"./it.json": [
		32718,
		32718
	],
	"./ja.json": [
		69230,
		69230
	],
	"./ko.json": [
		27077,
		27077
	],
	"./pl.json": [
		81995,
		81995
	],
	"./pt-br.json": [
		73930,
		73930
	],
	"./pt.json": [
		80515,
		80515
	],
	"./ru.json": [
		18458,
		18458
	],
	"./tr.json": [
		17045,
		17045
	],
	"./zh.json": [
		26801,
		26801
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 10986;
module.exports = webpackAsyncContext;